import React from 'react';

const FrontPageRunToGoal = ({ isActiveWomensMode }) => {
    return (
        <>
            {/* FONDO (Reutilizamos la clase que usas en la portada) */}
            <div className='FrontPage--Riddle__Screen__Background'>
                {isActiveWomensMode ? (
                    // <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='FrontPage--Riddle__Screen__Background__Image' alt="Fondo" />
                    <img src='/img/games/runtogoal/copa-academias-adsl/background-frontpage.png' className='FrontPage--Riddle__Screen__Background__Image' alt="Fondo" />
                ) : (
                    // <img src='/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png' className='FrontPage--Riddle__Screen__Background__Image' alt="Fondo" />
                    <img src='/img/games/runtogoal/copa-academias-adsl/background-frontpage.png' className='FrontPage--Riddle__Screen__Background__Image' alt="Fondo" />
                )}
            </div>

            <div className="goal-intro">
                {/* Ocultamos la cancha y ponemos un fondo oscuro para resaltar el logo */}
                <div className="goal-intro__logo-container">
                    <div className='d-flex'>
                        <img src="/img/page/adsl-five.png" className="LogoADSLxZtudia" alt="Logo" style={{ maxWidth: '850px', width: '850px' }} />
                    </div>
                    <p className="goal-intro__text text-uppercase fw-bold" style={{ marginBottom: '250px' }}>Presentan</p>
                    {/* <p className="goal-intro__title text-uppercase fw-bold">Carrera Escuelas ADSL</p> */}
                </div>

                {/* El balón que cae del cielo y rebota */}
                <img src="/img/games/runtogoal/balon-grande.png" className="goal-intro__ball" alt="Balón" />
                {/* <img src="/img/games/runtogoal/carrera-atleti/lucho.png" className="goal-intro__ball" alt="Balón" /> */}
                {/* <img src="/img/games/runtogoal/copa-academias-adsl/personaje-portada.png" className="goal-intro__ball" alt="Balón" /> */}

                <p className='FooterCredits' style={{ position: 'fixed', bottom: '0', left: '50%', transform: 'translateX(-50%)', fontSize: '30px' }}>Hecho con ♥ por Interaktia | 2026</p>
            </div>
        </>
    );
};

export { FrontPageRunToGoal };